__turbopack_context__.v({
  "button": "ColourSwatch-module-scss-module__1fVZpq__button",
  "buttonNoData": "ColourSwatch-module-scss-module__1fVZpq__buttonNoData",
  "buttonPdp": "ColourSwatch-module-scss-module__1fVZpq__buttonPdp",
  "buttonSelected": "ColourSwatch-module-scss-module__1fVZpq__buttonSelected",
  "buttonUnavailableForSize": "ColourSwatch-module-scss-module__1fVZpq__buttonUnavailableForSize",
  "dealDot": "ColourSwatch-module-scss-module__1fVZpq__dealDot",
  "dealDotActive": "ColourSwatch-module-scss-module__1fVZpq__dealDotActive",
  "imageInner": "ColourSwatch-module-scss-module__1fVZpq__imageInner",
  "inner": "ColourSwatch-module-scss-module__1fVZpq__inner",
  "screenReader": "ColourSwatch-module-scss-module__1fVZpq__screenReader",
  "wrapper": "ColourSwatch-module-scss-module__1fVZpq__wrapper",
  "wrapperPdp": "ColourSwatch-module-scss-module__1fVZpq__wrapperPdp",
});
